import { accessRole } from "../../../../helpers/access_role";
import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
  Input,
  Label,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import Select from "../../../../helpers/ui/CustomSelect";
import {
  AvForm,
  AvGroup,
  AvField,
  AvInput,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, useHistory, Redirect } from "react-router-dom";
import Shimmer from "react-shimmer-effect";

import apiResponse from "../../../../services/apiResponse";

import IndexBloc from "../Index/Blocs/IndexBloc";
import CreateBloc from "../Create/Blocs/CreateBloc";

class IndexView extends Component {
  timer;
  indexBloc = new IndexBloc();
  createBloc = new CreateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      diklatBknOption: [],
    };
  }

  submitData = async () => {
    await this.createBloc.fetchUpdate(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
        training_type_bkn_name: this.state.diklatBknOption?.find(
          ({ id }) => id === values.training_type_bkn_id
        )?.jenis_diklat,
        training_type_uuid: this.props.uuid,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.indexBloc.fetchDetail({ uuid: this.props.uuid });
    // this.indexBloc.fetchDiklatBkn({});

    this.createBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({ detail: result.data.response });
          break;
        default:
          break;
      }
    });

    this.indexBloc.diklatBknChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({ diklatBknOption: result.data.response });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.indexBloc.detailChannel?.unsubscribe();
    this.createBloc.diklatBknChannel?.unsubscribe();
  }

  render() {
    const { detail } = this.state;
    return (
      <Fragment>
        <Container fluid>
          <Card>
            <CardBody>
              <div className="float-end">
                <Link to={`/master/jenis-diklat.html`}>
                  <Button outline color="primary">
                    <i className="uil uil-backward"></i> Kembali
                  </Button>
                </Link>
              </div>
              <CardTitle>Detail Jenis Diklat</CardTitle>
              <hr />
              <AvForm
                className="needs-validation"
                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
              >
                <Row className="mb-3">
                  <label
                    htmlFor="training_type_name"
                    className="col-md-3 col-form-label"
                  >
                    Nama Jenis Pelatihan <span className="text-danger">*</span>
                  </label>
                  <Col md="3">
                    {detail ? (
                      <AvField
                        name="training_type_name"
                        placeholder="Nama Jenis Pelatihan..."
                        type="text"
                        errorMessage="Masukkan Nama Jenis Pelatihan"
                        className="form-control"
                        validate={{ required: { value: true } }}
                        id="training_type_description"
                        value={detail?.training_type_name}
                      />
                    ) : (
                      <Shimmer>
                        <div
                          style={{
                            width: "480px",
                            height: "16px",
                            alignSelf: "center",
                            borderRadius: "8px",
                            marginTop: "calc(0.47rem + 1px)",
                            marginBottom: "calc(0.47rem + 1px)",
                            fontSize: "inherit",
                            lineHeight: "1.5",
                          }}
                        />
                      </Shimmer>
                    )}
                  </Col>
                </Row>

                <Row className="mb-3">
                  <label
                    htmlFor="training_type_description"
                    className="col-md-3 col-form-label"
                  >
                    Deskripsi Jenis Pelatihan{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <Col md="3">
                    {detail ? (
                      <AvField
                        name="training_type_description"
                        placeholder="Deskripsi Jenis Pelatihan..."
                        type="textarea"
                        errorMessage="Masukkan Deskripsi Jenis Pelatihan"
                        className="form-control"
                        validate={{ required: { value: true } }}
                        id="training_type_description"
                        value={detail?.training_type_description}
                      />
                    ) : (
                      <Shimmer>
                        <div
                          style={{
                            width: "480px",
                            height: "16px",
                            alignSelf: "center",
                            borderRadius: "8px",
                            marginTop: "calc(0.47rem + 1px)",
                            marginBottom: "calc(0.47rem + 1px)",
                            fontSize: "inherit",
                            lineHeight: "1.5",
                          }}
                        />
                      </Shimmer>
                    )}
                  </Col>
                </Row>


                <Row className="mb-3">
                      <label
                        htmlFor="training_type_description"
                        className="col-md-3 col-form-label"
                      >
                        Jenis Diklat{" "}
                        <span className="text-danger">*</span>
                      </label>
                    <Col md="3">
                    {detail ? (
                      <Select
                      name="training_type_type"
                      errorMessage="Pilih Jenis Diklat"
                      options={[
                        { value: "1", label: "Struktural" },
                        { value: "2", label: "Fungsional" },
                        { value: "3", label: "Teknis" },
                      ]}
                      defaultValue={
                        detail?.training_type_type
                      }
                      placeholder="Pilih Jenis Diklat"
                      validate={{ required: { value: true } }}
                      // onChange={this.onChangeCategorySelected}
                      // isDisabled={
                      //   this.state.detailUuid != null ? true : false
                      // }
                    />
                    ) : (
                      <Shimmer>
                        <div
                          style={{
                            width: "480px",
                            height: "16px",
                            alignSelf: "center",
                            borderRadius: "8px",
                            marginTop: "calc(0.47rem + 1px)",
                            marginBottom: "calc(0.47rem + 1px)",
                            fontSize: "inherit",
                            lineHeight: "1.5",
                          }}
                        />
                      </Shimmer>
                    )}
                  </Col>
                    </Row>

                {/* <Row className="mb-3">
                                    <label
                                        htmlFor="training_type_id"
                                        className="col-md-3 col-form-label"
                                    >
                                        Jenis Pelatihan BKN <span className="text-danger">*</span>
                                    </label>
                                    <Col md="3">
                                    { detail ? 
                                        <Select
                                            name="training_type_bkn_id"
                                            placeholder="Pilih Jenis Pelatihan BKN..."
                                            errorMessage="Pilih Jenis Pelatihan BKN"
                                            className="form-control"
                                            validate={{ required: { value: true } }}
                                            options={this.state.diklatBknOption}
                                            optionLabel="jenis_diklat"
                                            optionValue="id"
                                            isLoading={!this.state.diklatBknOption?.length}
                                            defaultValue={detail?.training_type_bkn_id}
                                        />
                                         :
                                            <Shimmer>
                                                <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                            marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row> */}

                <Row className="mb-3">
                  <Col md="3"></Col>
                  <Col md="9">
                    <Link to="?">
                      <Button color="danger">
                        <i className="uil-arrow-left"></i> Kembali
                      </Button>
                    </Link>{" "}
                    <Button color="success" type="submit">
                      <i className="uil-arrow-up-right"></i> Simpan Data
                    </Button>
                  </Col>
                </Row>
              </AvForm>
            </CardBody>
          </Card>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/master/jenis-diklat.html?" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
